export default __webpack_public_path__ + "static/103-min-min-6654982dd2fbf8c50d7380f48efeda0b.jpg";